









/* Created- 24 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
@Component(
	{
		name: "ParticaCard"
	})
export default class ParticaCard extends Vue {
	@Prop() private title: string; // your data

	private getWidth() {
		// @ts-ignore
		if (this.$vuetify.breakpoint.smAndDown) {
			return "98%";
		} else {
			return 800;
		}
	}
}
